import {
  ADD_ADVANCE,
  ADD_LICENSE,
  ADD_MANAGER_PIN,
  ADD_MANAGER_UIDX,
  ADD_PIN,
  ADD_MANAGER,
  RESET_MANAGER,
} from "../Actions/SessionActions";

const defaultState = {
  license: {
    licenseId: "",
    licenseName: "",
  },
  advanceMade: "",
  sessionPin: "",
  managerPin: "",
  manageruidx: "",
  manager: {
    label: "",
    uidx: "",
  },
};

const sessionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_LICENSE: {
      return { ...state, license: action.payload };
    }
    case ADD_ADVANCE: {
      return { ...state, advanceMade: action.payload };
    }
    case ADD_PIN: {
      return { ...state, sessionPin: action.payload };
    }
    case ADD_MANAGER_PIN: {
      return { ...state, managerPin: action.payload };
    }
    case ADD_MANAGER_UIDX: {
      return { ...state, manageruidx: action.payload };
    }
    case ADD_MANAGER: {
      return { ...state, manager: action.payload };
    }
    case RESET_MANAGER: {
      return { ...state, manager: defaultState.manager };
    }
    default:
      return state;
  }
};

export const getLicense = (state) => state.session.license;
export const getAmount = (state) => state.session.advanceMade;
export const getsessionPin = (state) => state.session.sessionPin;
export const getmangerPin = (state) => state.session.managerPin;
export const getmangeruidx = (state) => state.session.manageruidx;
export const getManager = (state) => state.session.manager;

export default sessionReducer;
